
import { Injectable } from '@angular/core';
import { KeycloakService } from 'src/app/authentication/keycloak.service';

export enum ActionType {
  Create = 1,
  Update = 2,
  Verify = 3,
  Delete = 4,
  AdminRevert = 5,
}

export class DataBaseAction {
  userName: string = '';
  timestamp: number = 0;
  userAction: ActionType = ActionType.Create;
}

@Injectable({
  providedIn: 'root'
})
export class DataBaseActionService {

  constructor(private _keycloakService: KeycloakService) { }

  userAction(actionType: ActionType) {
    const action: DataBaseAction = {
      userName: this._keycloakService.getUser().username,
      timestamp: new Date().getTime(),
      userAction: actionType
    };
    return action;
  }
}
